export const ADD_FORM = "add_rate_form";
export const SEARCH_FORM = "search_rate_form";
export const CHANGE_FORM = "change_rate_form";

export enum RATEGROUP {
  NORMAL_PAYMENT = 1,
  PAYMENT_COLLECTION,
  WALLEX_PAYMENT
}
